import { render, staticRenderFns } from "./RadioStatPanel.vue?vue&type=template&id=50034bce&scoped=true&"
import script from "./RadioStatPanel.vue?vue&type=script&lang=js&"
export * from "./RadioStatPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50034bce",
  null
  
)

export default component.exports